export const names: { [key: string]: any } = {
	INDEX_EIGHT: "Показатель №8",
	INDEX_NINE: "Показатель №9",
	K_NP: "КНП",
	D_NDPI: "ΔНДПИ",
	K_NDPI: "КНДПИ",
	D_DIV: "ΔДИВ",
	K_NS: "Кнс",
	D_VSO: "ΔВСО",
	B_MIDDLE: "Б (усредн)",
	INDEX_TEN: "Показатель №10",
};
export const makeString = (num: number | string) => {
	return String(num).replace(".", ",");
};
export const prettify = (num: string | number) => {
	let n: string;
	if (typeof num === "number") {
		n = String(num);
	} else {
		n = num;
	}
	let separator = " ";
	const temp = makeString(n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + separator)).split(",");
	if (/\s+/g.test(temp[1])) {
		temp[1] = temp[1].replace(/\s/g, "");
	}
	return temp.join(",");
};

export const generateIndex = (index: string) => {
	let result = {
		simple: "",
		endOf: "",
	};
	if (
		index === "INDEX_EIGHT" ||
		index === "INDEX_NINE" ||
		index === "K_NS" ||
		index === "INDEX_TEN" ||
		index === "K_NDPI"
	) {
		result.simple = "≈ ";
	}
	if (index === "INDEX_EIGHT" || index === "INDEX_NINE") {
		result.endOf = " %";
	}
	if (index === "D_DIV" || index === "D_NDPI" || index === "INDEX_TEN" || index === "D_VSO" || index === "B_MIDDLE") {
		result.endOf = " руб.";
	}
	if (index === "INDEX_TEN") {
		result.endOf = " млн.ед.";
	}
	if (index === "K_NDPI") {
		result.endOf = " руб./тонн";
	}
	return result;
};
export const getTopChord = (arrAnchor: HTMLDivElement[]) => {
	const arr: number[] = [];
	for (let i = 0; i < arrAnchor.length; i++) {
		arr.push(arrAnchor[i].getBoundingClientRect().top);
	}
	return arr;
};
